import Intercom from "@intercom/messenger-js-sdk";
import usersService from "@/services/users";
import serviceHandler from "@/helpers/handlers/service";
import { isFeatureFlagEnabled, FEATURE_FLAG } from "@/helpers/posthog";

export const intercomMixin = {
  methods: {
    async setIntercom() {
      if (isFeatureFlagEnabled(FEATURE_FLAG.CN_5810_INTERCOM_INTEGRATION)) {
        const userAuthEmail = this.$store.state.auth.user.email;
        const { user_id } = this.$store.state.company.company.company_user;
        const facilitiesCount = this.$store.getters["company/facilitiesCount"];
        const { hmac } = await serviceHandler(usersService.getUserDetails());
        const selectedLanguage = this.$store.state.settings.selectedLocale;
        Intercom({
          app_id: process.env.VUE_APP_INTERCOM_APP_ID,
          user_id,
          email: userAuthEmail,
          user_hash: hmac,
          locations_count: facilitiesCount,
          lang: selectedLanguage
        });
      }
    }
  }
};
